@if (isLoading) {
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </div>
  </div>
} @else {
  <gung-table [config]="config"></gung-table>
}
